import React, { useCallback, useEffect } from "react";
import { connect } from "react-redux";

import HalfLayout from "components/HalfLayout";
import Map from "components/Map";

import MapActioner from "services/map/actioner";
import DisplaysActioner from "services/displays/actioner";

import DisplaysLayout from "scenes/Displays/components/DisplaysLayout";
import MapComponent from "scenes/Displays/components/MapComponent";

function Displays({
  currentFloor,
  map,
  displays,
  retrieveMapData,
  setFilter,
  setCenterToDefault,
}) {
  const initializeData = useCallback(() => {
    retrieveMapData();
  }, [retrieveMapData]);

  useEffect(() => {
    if (map?.initialized) {
      const timestamp = Math.round(new Date().getTime() / 1000);
      handleTimestampChange(timestamp);
    }
  }, [currentFloor, map?.initialized]);

  const handleRecenter = useCallback(
    (mapRef) => {
      const displaysFromCurrentFloor = displays?.items?.filter(
        (display) => display?.floor_level === currentFloor
      );
      if (!displaysFromCurrentFloor?.length) return null;

      const positions = displaysFromCurrentFloor.map(
        (display) => display?.position
      );

      mapRef.fitBounds(positions, {
        padding: [50, 50],
      });
    },
    [displays?.items, currentFloor]
  );

  const handleTimestampChange = useCallback(
    (timestamp) => {
      setFilter("timestamp", timestamp);
      initializeData();
    },
    [initializeData, setFilter]
  );

  return (
    <HalfLayout
      leftComponent={
        <DisplaysLayout onTimestampChange={handleTimestampChange} />
      }
      rightComponent={
        <Map
          floorsButton
          onRecenter={handleRecenter}
          mapComponent={<MapComponent />}
          withCheckboxOptions={{
            labels: false,
            displays: false,
            aisles: false,
            spaceLabels: false,
          }}
        />
      }
    />
  );
}

const mapStateToProps = (state) => ({
  currentFilters: state.Displays.filters,
  currentFloor: state.Map?.config?.currentFloor,
  contract: state.Contract.contract,
  map: state.Map,
  displays: state.Displays.list,
});

const mapDispatchToProps = (dispatch) => ({
  setFilter: (key, value) => dispatch(DisplaysActioner.setFilter(key, value)),
  retrieveMapData: () => dispatch(MapActioner.retrieveMapDataForDisplaysTab()),
  setCenterToDefault: () => dispatch(MapActioner.setCenterToDefault()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Displays);
